import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { obtenerServiciosModalidadPorInstitucion } from "../../Services/Rest";

function InfoServiciosModalidadEvaluador(props) {
  let { id } = useParams();
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Página actual
  const [itemsPerPage] = useState(5); // Elementos por página

  // Obtener datos de la API
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerServiciosModalidadPorInstitucion + id,
    })
      .then((Response) => {
        setList(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  // Calcular el índice del primer y último elemento de la página actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);

  // Función para ir a la página siguiente
  const nextPage = () => {
    if (currentPage < Math.ceil(list.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Función para ir a la página anterior
  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Número total de páginas
  const totalPages = Math.ceil(list.length / itemsPerPage);

  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Informacion Servicios{" "}
                </h6>
              </div>
              <div class="card-body">
                <hr />
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Sede</th>
                        <th>Grupo del Servicio</th>
                        <th>Modalidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item) => {
                        return (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.sede}</td>
                            <td>{item.grupoServicio}</td>
                            <td>{item.modalidad}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {/* Paginación */}
                <div className="pagination">
                  <button
                    onClick={prevPage}
                    disabled={currentPage === 1}
                    className="btn btn-primary"
                  >
                    Anterior
                  </button>

                  {/* Mostrar "Página X de Y" */}
                  <span className="page-info">
                    Página {currentPage} de {totalPages}
                  </span>

                  <button
                    onClick={nextPage}
                    disabled={currentPage === totalPages}
                    className="btn btn-primary"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default InfoServiciosModalidadEvaluador;
